var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.834 2.3335H10.5007C4.66732 2.3335 2.33398 4.66683 2.33398 10.5002V17.5002C2.33398 23.3335 4.66732 25.6668 10.5007 25.6668H17.5007C23.334 25.6668 25.6673 23.3335 25.6673 17.5002V15.1668",
    stroke: "#00B96B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7161 3.52363L9.52279 12.717C9.17279 13.067 8.82279 13.7553 8.75279 14.257L8.25112 17.7686C8.06446 19.0403 8.96279 19.927 10.2345 19.752L13.7461 19.2503C14.2361 19.1803 14.9245 18.8303 15.2861 18.4803L24.4795 9.28696C26.0661 7.70029 26.8128 5.85696 24.4795 3.52363C22.1461 1.19029 20.3028 1.93696 18.7161 3.52363Z",
    stroke: "#00B96B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3945 4.84229C18.1762 7.63062 20.3579 9.81229 23.1579 10.6056",
    stroke: "#00B96B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.57eed74d55c9836a77722678f7d952cb.svg";
export { ForwardRef as ReactComponent };